import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, TransitionGroup as _TransitionGroup, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f8f9203a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ctrl-bet-box-group-root" }
const _hoisted_2 = {
  key: 0,
  class: "ctrl-bet-box-group"
}
const _hoisted_3 = {
  key: 0,
  class: "bet-view-r special-bets-row"
}
const _hoisted_4 = { class: "bet-view-r" }
const _hoisted_5 = { class: "bet-view-r" }
const _hoisted_6 = {
  key: 1,
  class: "ctrl-bet-box-group"
}
const _hoisted_7 = { class: "bet-view-r" }
const _hoisted_8 = { class: "bet-view-r" }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "toast-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ctrl_bet_box = _resolveComponent("ctrl-bet-box")!
  const _component_bet_start_stop_pop = _resolveComponent("bet-start-stop-pop")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.gameType === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.playMode === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_ctrl_bet_box, {
                  class: "bet-view-r-item",
                  color: 3,
                  label: _ctx.t('bettype.bear8'),
                  ratio: "1:25",
                  totalBet: _ctx.bearEightAmount,
                  onPlaceBet: _ctx.placeBet,
                  onCancelBet: _ctx.cancelTempBetCL,
                  betType: 10,
                  tempBet: _ctx.tempBear8Bet,
                  confirmedBet: _ctx.bear8Bet,
                  width: 52,
                  height: 40,
                  ref: "bear8Box",
                  desk: _ctx.mData,
                  "game-type": _ctx.gameType,
                  isGrayMode: !_ctx.allowBetOnB8andD7,
                  "allow-bet": _ctx.mData?.status === 1,
                  onOnError: _ctx.handleToastMessage,
                  "show-flashing-bg": _ctx.GWin === 8 || _ctx.GWin === 81 || _ctx.GWin === 82 || _ctx.GWin === 83
                }, null, 8, ["label", "totalBet", "onPlaceBet", "onCancelBet", "tempBet", "confirmedBet", "desk", "game-type", "isGrayMode", "allow-bet", "onOnError", "show-flashing-bg"]),
                _createVNode(_component_ctrl_bet_box, {
                  class: "bet-view-r-item",
                  color: 4,
                  label: _ctx.t('bettype.smalltiger'),
                  ratio: "1:22",
                  totalBet: _ctx.smallTigerAmount,
                  onPlaceBet: _ctx.placeBet,
                  onCancelBet: _ctx.cancelTempBetCL,
                  betType: 11,
                  tempBet: _ctx.tempSmallTigerBet,
                  confirmedBet: _ctx.smallTigerBet,
                  width: 52,
                  height: 40,
                  ref: "smallTigerBox",
                  desk: _ctx.mData,
                  "game-type": _ctx.gameType,
                  isGrayMode: _ctx.isSmallTigerGray,
                  "allow-bet": _ctx.mData?.status === 1,
                  onOnError: _ctx.handleToastMessage,
                  "error-message": _ctx.smallTigerGrayError,
                  "show-flashing-bg": _ctx.GWin === 10 || _ctx.GWin === 101 || _ctx.GWin === 102 || _ctx.GWin === 103
                }, null, 8, ["label", "totalBet", "onPlaceBet", "onCancelBet", "tempBet", "confirmedBet", "desk", "game-type", "isGrayMode", "allow-bet", "onOnError", "error-message", "show-flashing-bg"]),
                _createVNode(_component_ctrl_bet_box, {
                  class: "bet-view-r-item",
                  color: 4,
                  label: _ctx.t('bettype.bigtiger'),
                  ratio: "1:50",
                  totalBet: _ctx.bigTigerAmount,
                  onPlaceBet: _ctx.placeBet,
                  onCancelBet: _ctx.cancelTempBetCL,
                  betType: 12,
                  tempBet: _ctx.tempBigTigerBet,
                  confirmedBet: _ctx.bigTigerBet,
                  width: 52,
                  height: 40,
                  ref: "bigTigerBox",
                  desk: _ctx.mData,
                  "game-type": _ctx.gameType,
                  isGrayMode: _ctx.isBigTigerGray,
                  "allow-bet": _ctx.mData?.status === 1,
                  onOnError: _ctx.handleToastMessage,
                  "error-message": _ctx.bigTigerGrayError,
                  "show-flashing-bg": _ctx.GWin === 9 || _ctx.GWin === 91 || _ctx.GWin === 92 || _ctx.GWin === 93
                }, null, 8, ["label", "totalBet", "onPlaceBet", "onCancelBet", "tempBet", "confirmedBet", "desk", "game-type", "isGrayMode", "allow-bet", "onOnError", "error-message", "show-flashing-bg"]),
                _createVNode(_component_ctrl_bet_box, {
                  class: "bet-view-r-item",
                  color: 1,
                  label: _ctx.t('bettype.dragon7'),
                  ratio: "1:40",
                  totalBet: _ctx.dragonSevenAmount,
                  onPlaceBet: _ctx.placeBet,
                  onCancelBet: _ctx.cancelTempBetCL,
                  betType: 13,
                  tempBet: _ctx.tempDragon7Bet,
                  confirmedBet: _ctx.dragon7Bet,
                  width: 52,
                  height: 40,
                  ref: "dragon7Box",
                  desk: _ctx.mData,
                  "game-type": _ctx.gameType,
                  isGrayMode: !_ctx.allowBetOnB8andD7,
                  "allow-bet": _ctx.mData?.status === 1,
                  onOnError: _ctx.handleToastMessage,
                  "show-flashing-bg": _ctx.GWin === 7 || _ctx.GWin === 71 || _ctx.GWin === 72 || _ctx.GWin === 73
                }, null, 8, ["label", "totalBet", "onPlaceBet", "onCancelBet", "tempBet", "confirmedBet", "desk", "game-type", "isGrayMode", "allow-bet", "onOnError", "show-flashing-bg"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_ctrl_bet_box, {
              class: "bet-view-r-item",
              color: 3,
              label: `${_ctx.t('game.betting.playerpair')} P.P`,
              ratio: "1:11",
              totalBet: _ctx.playerPairAmount,
              onPlaceBet: _ctx.placeBet,
              onCancelBet: _ctx.cancelTempBetCL,
              betType: 6,
              tempBet: _ctx.tempPpBet,
              confirmedBet: _ctx.ppBet,
              width: 70,
              height: 40,
              ref: "playerPBox",
              desk: _ctx.mData,
              "game-type": _ctx.gameType,
              "show-flashing-bg": _ctx.isBluePair
            }, null, 8, ["label", "totalBet", "onPlaceBet", "onCancelBet", "tempBet", "confirmedBet", "desk", "game-type", "show-flashing-bg"]),
            _createVNode(_component_ctrl_bet_box, {
              class: "bet-view-r-item",
              color: 2,
              label: `${_ctx.t('game.betting.tie')} Tie`,
              ratio: "1:8",
              totalBet: _ctx.tieTotal,
              onPlaceBet: _ctx.placeBet,
              onCancelBet: _ctx.cancelTempBetCL,
              betType: 2,
              tempBet: _ctx.tempTBet,
              confirmedBet: _ctx.tBet,
              width: 70,
              height: 40,
              ref: "tieBox",
              desk: _ctx.mData,
              "game-type": _ctx.gameType,
              "show-flashing-bg": _ctx.isTieWin
            }, null, 8, ["label", "totalBet", "onPlaceBet", "onCancelBet", "tempBet", "confirmedBet", "desk", "game-type", "show-flashing-bg"]),
            _createVNode(_component_ctrl_bet_box, {
              class: "bet-view-r-item",
              color: 1,
              label: `${_ctx.t('game.betting.bankerpair')} B.P`,
              ratio: "1:11",
              totalBet: _ctx.bankerPairAmount,
              onPlaceBet: _ctx.placeBet,
              onCancelBet: _ctx.cancelTempBetCL,
              betType: 7,
              tempBet: _ctx.tempBpBet,
              confirmedBet: _ctx.bpBet,
              width: 70,
              height: 40,
              ref: "bankerPBox",
              desk: _ctx.mData,
              "game-type": _ctx.gameType,
              "show-flashing-bg": _ctx.isRedPair
            }, null, 8, ["label", "totalBet", "onPlaceBet", "onCancelBet", "tempBet", "confirmedBet", "desk", "game-type", "show-flashing-bg"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_ctrl_bet_box, {
              class: "bet-view-r-item",
              color: 3,
              label: `${_ctx.t('game.betting.player')} Player`,
              ratio: "1:1",
              totalBet: _ctx.playerTotal,
              onPlaceBet: _ctx.placeBet,
              onCancelBet: _ctx.cancelTempBetCL,
              betType: 1,
              tempBet: _ctx.tempPBet,
              confirmedBet: _ctx.pBet,
              width: 95,
              height: 40,
              ref: "playerBox",
              desk: _ctx.mData,
              "game-type": _ctx.gameType,
              "show-flashing-bg": _ctx.isBlueWin
            }, null, 8, ["label", "totalBet", "onPlaceBet", "onCancelBet", "tempBet", "confirmedBet", "desk", "game-type", "show-flashing-bg"]),
            (_ctx.playMode === 2)
              ? (_openBlock(), _createBlock(_component_ctrl_bet_box, {
                  key: 0,
                  class: "bet-view-r-item",
                  color: 4,
                  label: _ctx.t('bettype.super6'),
                  ratio: "1:12",
                  totalBet: _ctx.superSixAmount,
                  onPlaceBet: _ctx.placeBet,
                  onCancelBet: _ctx.cancelTempBetCL,
                  betType: 9,
                  tempBet: _ctx.tempSuper6Bet,
                  confirmedBet: _ctx.super6Bet,
                  width: 60,
                  height: 40,
                  ref: "super6Box",
                  desk: _ctx.mData,
                  "game-type": _ctx.gameType,
                  isGrayMode: _ctx.isSuper6Gray,
                  "allow-bet": _ctx.mData?.status === 1,
                  onOnError: _ctx.handleToastMessage,
                  "error-message": _ctx.super6GrayError,
                  "show-flashing-bg": _ctx.GWin === 9 ||
                        _ctx.GWin === 91 ||
                        _ctx.GWin === 92 ||
                        _ctx.GWin === 93 ||
                        _ctx.GWin === 10 ||
                        _ctx.GWin === 101 ||
                        _ctx.GWin === 102 ||
                        _ctx.GWin === 103
                }, null, 8, ["label", "totalBet", "onPlaceBet", "onCancelBet", "tempBet", "confirmedBet", "desk", "game-type", "isGrayMode", "allow-bet", "onOnError", "error-message", "show-flashing-bg"]))
              : _createCommentVNode("", true),
            _createVNode(_component_ctrl_bet_box, {
              class: "bet-view-r-item",
              color: 1,
              label: `${_ctx.t('game.betting.banker')} Banker`,
              ratio: !_ctx.isFreeBaccarat ? '1:0.95' : '1:1',
              totalBet: _ctx.bankerTotal,
              onPlaceBet: _ctx.placeBet,
              onCancelBet: _ctx.cancelTempBetCL,
              betType: 0,
              tempBet: _ctx.tempBBet,
              confirmedBet: _ctx.bBet,
              isFreeBaccarat: _ctx.isFreeBaccarat,
              width: 95,
              height: 40,
              ref: "bankerBox",
              desk: _ctx.mData,
              "game-type": _ctx.gameType,
              "show-flashing-bg": _ctx.isRedWin
            }, null, 8, ["label", "ratio", "totalBet", "onPlaceBet", "onCancelBet", "tempBet", "confirmedBet", "isFreeBaccarat", "desk", "game-type", "show-flashing-bg"])
          ])
        ]))
      : (_ctx.gameType === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_ctrl_bet_box, {
                class: "bet-view-r-item",
                color: 2,
                label: "和 Tie",
                ratio: "1:8",
                onPlaceBet: _ctx.placeBet,
                onCancelBet: _ctx.cancelTempBetCL,
                tempBet: _ctx.tempTBet,
                totalBet: _ctx.tieTotal,
                confirmedBet: _ctx.tBet,
                betType: 3,
                height: 40,
                width: 130,
                ref: "tieTGBox",
                desk: _ctx.mData,
                "show-flashing-bg": _ctx.isTieWin
              }, null, 8, ["onPlaceBet", "onCancelBet", "tempBet", "totalBet", "confirmedBet", "desk", "show-flashing-bg"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_ctrl_bet_box, {
                class: "bet-view-r-item",
                color: 1,
                label: "龙 Dragon",
                ratio: "1:1",
                onPlaceBet: _ctx.placeBet,
                onCancelBet: _ctx.cancelTempBetCL,
                tempBet: _ctx.tempDrBet,
                totalBet: _ctx.bankerTotal,
                confirmedBet: _ctx.drBet,
                betType: 4,
                width: 95,
                height: 40,
                ref: "dragonBox",
                desk: _ctx.mData,
                "show-flashing-bg": _ctx.isBlueWin
              }, null, 8, ["onPlaceBet", "onCancelBet", "tempBet", "totalBet", "confirmedBet", "desk", "show-flashing-bg"]),
              _createVNode(_component_ctrl_bet_box, {
                class: "bet-view-r-item",
                color: 3,
                label: "虎 Tiger",
                ratio: "1:1",
                onPlaceBet: _ctx.placeBet,
                onCancelBet: _ctx.cancelTempBetCL,
                tempBet: _ctx.tempTgBet,
                totalBet: _ctx.playerTotal,
                confirmedBet: _ctx.tgBet,
                betType: 5,
                width: 95,
                height: 40,
                ref: "tigerBox",
                desk: _ctx.mData,
                "show-flashing-bg": _ctx.isRedWin
              }, null, 8, ["onPlaceBet", "onCancelBet", "tempBet", "totalBet", "confirmedBet", "desk", "show-flashing-bg"])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9)),
    (_ctx.showStartAndEndNorify)
      ? (_openBlock(), _createBlock(_component_bet_start_stop_pop, {
          key: 3,
          status: _ctx.timerNotifyStatus,
          class: "start-or-stop-game",
          onHide: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showStartAndEndNorify = false))
        }, null, 8, ["status"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_TransitionGroup, {
        class: "toast-container",
        tag: "div",
        name: "list",
        appear: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toastMessage, (toast, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "toast",
              key: index
            }, [
              _createElementVNode("span", null, _toDisplayString(toast.message), 1)
            ]))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}